export class TranscriptionEvent {
  private listeners: ((event: any) => void)[] = [];

  addEventListener(listener: (event: any) => void): void {
    this.listeners.push(listener);
  }

  dispatchEvent(event: any): void {
    this.listeners.forEach(listener => listener(event));
  }
}